module.exports = __webpack_public_path__ + "img/asia-admin01.44bf850f.png";